module.exports = __webpack_public_path__ + "img/404big.1669e1d9.png";